<template>
  <div>
    <department-modal
      v-if="isPowerUserOrAdministrator"
      :show="showDepartmentModal"
      :current-operation="currentOperation"
      :department="department"
      :institution-id="linkedInstitutionId"
      @close="closeDepartmentModal"
    />

    <p>
      Liste des départements
      <button
        v-show="!editingDisabled"
        id="btn-add"
        type="button"
        class="btn btn-icon btn-round btn-success"
        aria-label="Ajouter un département"
        @click="createDepartment"
      >
        <i class="fa fa-plus" />
      </button>
    </p>
    <div class="row text-left">
      <div
        v-for="department in departments"
        :key="department.id"
        class="col-md-3"
      >
        <div
          :class="{ 'clickable-element': !editingDisabled }"
          class="department-card"
          @click="departmentCardClicked(department, $event)"
        >
          <b> {{ department.name }} </b><br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPowerUserOrAdministrator } from '@/services/AuthService';
import DepartmentModal from 'src/components/ApplicationViews/Modals/DepartmentModal.vue';

export default {
  name: 'DepartmentsCards',
  components: {
    DepartmentModal,
  },
  props: {
    departments: Array,
    editingDisabled: Boolean,
    linkedInstitutionId: Number,
    fetch: Function,
  },
  data() {
    return {
      showDepartmentModal: false,
      currentOperation: null,
      department: {},
    };
  },
  computed: {
    isPowerUserOrAdministrator,
  },
  methods: {
    departmentCardClicked(department, event) {
      if (this.editingDisabled) {
        event.stopPropagation();
      } else {
        this.currentOperation = 'edit';
        this.department = {
          id: department.id,
          name: department.name,
        };
        this.showDepartmentModal = true;
      }
    },
    createDepartment() {
      this.currentOperation = 'create';
      this.department = {};
      this.showDepartmentModal = true;
    },
    closeDepartmentModal() {
      this.showDepartmentModal = false;
      this.fetch(this.linkedInstitutionId);
    },
  },
};
</script>

<style scoped>
.department-card {
  background-color: lightcoral;
  padding: 15px;
  border: none;
  border-radius: 5px;
  margin-bottom: 10px;
}
</style>
